var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _mask, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoValentine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 191,
    viewBox: "0 0 272 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4475 109.032L70.3877 54.0121C86.0042 38.658 111.339 38.8497 126.729 54.4304L136.989 64.8349C152.361 80.4329 152.169 105.756 136.57 121.11L80.63 176.147C65.0135 191.501 39.6782 191.31 24.2885 175.712L14.0288 165.307C-1.34344 149.709 -1.1515 124.404 14.4475 109.032Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 3,
    strokeMiterlimit: 22.93
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8565 149.657C14.5347 142.354 14.3951 130.259 25.4401 128.935C58.5575 121.354 33.0302 96.6583 55.3644 88.2755C68.3985 79.5092 83.823 89.8614 84.1022 64.7651C84.3639 45.6292 110.973 67.9545 124.408 69.5404C142.817 75.1522 143.602 105.547 130.393 111.385C120.552 117.886 108.705 110.461 100.87 119.75C89.7032 133.431 100.469 145.526 88.0979 153.23C52.6424 163.965 52.0492 191.902 19.8565 149.639V149.657Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2207 108.335L81.7816 175.259",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9807 52.4958L137.739 119.419",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8362 80.1715L110.24 147.269",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9143 170.501L131.266 59.9725",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4027 103.874C70.562 103.874 75.5698 98.8194 75.5698 92.6151C75.5698 86.4107 70.5446 81.3566 64.4027 81.3566C58.2608 81.3566 53.2356 86.4107 53.2356 92.6151C53.2356 98.8194 58.2608 103.874 64.4027 103.874Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8729 160.95C84.0323 160.95 89.04 155.896 89.04 149.692C89.04 143.487 84.0148 138.433 77.8729 138.433C71.731 138.433 66.7058 143.487 66.7058 149.692C66.7058 155.896 71.731 160.95 77.8729 160.95Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.254 93.2076V93.3993C130.254 99.6211 125.246 104.658 119.087 104.658C112.927 104.658 107.919 99.6211 107.919 93.3993V93.2076H130.271H130.254Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.183 140.856L37.0434 140.995C32.7161 145.457 25.5971 145.596 21.1826 141.309C16.7507 137.022 16.6809 129.928 21.0081 125.449L21.1477 125.31L37.183 140.838V140.856Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.377 52.4958C92.2507 57.3757 96.2116 71.4226 104.238 77.505C113.067 72.6252 114.637 56.2777 104.377 52.4958Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.36 77.3481L104.098 52.6004",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.447 61.7153L99.2126 55.476",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.622 73.8974L96.9792 64.7303",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.22 67.5188L97.3806 59.5716",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103.976 62.1161L109.437 55.476",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.029 73.8974L111.601 64.556",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.43 67.5188L110.711 59.7285",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7392 122.905C92.3379 109.851 77.7683 108.701 69.2883 114.139C70.8238 124.09 85.6377 131.235 92.7392 122.905Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6372 114.557L92.7391 122.626",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7532 119.454L91.7097 117.049",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5513 115.759L83.5613 111.507",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6755 117.589L88.883 114.139",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6311 119.646L87.7839 125.99",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7605 115.202L78.4662 125.031",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.606 117.781L83.7533 126.356",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5408 174.178C58.54 175.468 61.5761 161.194 57.2837 152.097C47.1984 152.323 38.195 166.057 45.5408 174.178Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9521 152.149L45.8374 174.23",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9204 166.213L51.5082 173.934",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2598 155.112L57.9468 167.364",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6599 160.95L54.6839 171.947",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7111 165.969L42.9236 168.618",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8006 155.391L44.8953 160.114",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.468 160.846L43.29 164.837",
    stroke: "#696969",
    strokeMiterlimit: 22.93
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.791 151.069L105.651 150.929C101.376 146.415 101.551 139.305 106.035 135.087C110.519 130.869 117.621 131.079 121.896 135.61L122.035 135.749L105.791 151.086V151.069Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.118 134.833C238.526 131.183 243.214 129.073 248.719 128.384V133.738C248.148 136.862 259.238 136.699 258.79 133.576V128.668C263.927 129.56 267.923 131.629 267.882 134.833V179.981C267.963 187.323 239.79 188.499 238.118 179.981V134.833Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.116 133.901C258.912 136.537 248.841 136.659 248.719 134.347L249.575 27.3399C249.738 24.4193 253.897 24.5816 254.346 27.7861L259.116 133.901Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M251.858 26.3258L252.021 19.4706",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.614 6.12509C257.037 11.6417 255.283 19.1055 252.103 21.9855C247.129 19.9167 248.107 10.5871 251.614 6.12509Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M238.077 134.915C237.425 144.974 269.105 143.879 267.882 135.199",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-41-inside-1_102_3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.741 107.51L192.77 124.54L192.77 124.54L192.77 124.54L209.799 107.51C214.074 103.235 214.074 96.3043 209.799 92.0293C205.524 87.7543 198.593 87.7543 194.318 92.0293L192.77 93.5774L191.222 92.0293C186.947 87.7543 180.016 87.7543 175.741 92.0293C171.466 96.3043 171.466 103.235 175.741 107.51Z"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.741 107.51L192.77 124.54L192.77 124.54L192.77 124.54L209.799 107.51C214.074 103.235 214.074 96.3043 209.799 92.0293C205.524 87.7543 198.593 87.7543 194.318 92.0293L192.77 93.5774L191.222 92.0293C186.947 87.7543 180.016 87.7543 175.741 92.0293C171.466 96.3043 171.466 103.235 175.741 107.51Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M192.77 124.54L191.356 125.954L192.77 127.368L194.184 125.954L192.77 124.54ZM175.741 107.51L177.155 106.096L175.741 107.51ZM192.77 124.54L194.184 123.125L192.77 121.711L191.356 123.125L192.77 124.54ZM192.77 124.54L191.356 125.954L192.77 127.368L194.184 125.954L192.77 124.54ZM209.799 107.51L211.213 108.925L209.799 107.51ZM192.77 93.5774L191.356 94.9916L192.77 96.4059L194.184 94.9916L192.77 93.5774ZM175.741 92.0293L177.155 93.4435L175.741 92.0293ZM194.184 123.125L177.155 106.096L174.326 108.925L191.356 125.954L194.184 123.125ZM191.356 123.125L191.356 123.125L194.184 125.954L194.184 125.954L191.356 123.125ZM194.184 123.125L194.184 123.125L191.356 125.954L191.356 125.954L194.184 123.125ZM208.385 106.096L191.356 123.125L194.184 125.954L211.213 108.925L208.385 106.096ZM208.385 93.4435C211.879 96.9374 211.879 102.602 208.385 106.096L211.213 108.925C216.269 103.869 216.269 95.6711 211.213 90.6151L208.385 93.4435ZM195.732 93.4435C199.226 89.9495 204.891 89.9495 208.385 93.4435L211.213 90.6151C206.157 85.559 197.96 85.559 192.904 90.615L195.732 93.4435ZM194.184 94.9916L195.732 93.4435L192.904 90.615L191.356 92.1632L194.184 94.9916ZM189.807 93.4435L191.356 94.9916L194.184 92.1632L192.636 90.6151L189.807 93.4435ZM177.155 93.4435C180.649 89.9495 186.314 89.9495 189.807 93.4435L192.636 90.6151C187.58 85.559 179.382 85.559 174.326 90.6151L177.155 93.4435ZM177.155 106.096C173.661 102.602 173.661 96.9374 177.155 93.4435L174.326 90.6151C169.27 95.6711 169.27 103.869 174.326 108.925L177.155 106.096Z",
    fill: "#696969",
    mask: "url(#path-41-inside-1_102_3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoValentine);
export default __webpack_public_path__ + "static/media/promo-valentine.f12b05612c05b5abfcf7aac388f92064.svg";
export { ForwardRef as ReactComponent };